// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
// JS Imports
import { formatFloatAsCurrencySymbol } from '../../../common/helpers.mjs'
import { shouldDisableDiscount } from '../../../js/validate'
// Asset Imports

export default function ImpPromotionDiscountRow({ order = 1 }) {
   const state = useQuoteContext()
   const discountCode = 'impPromotion'
   const { getString } = state

   if (
      (state.user_view == 'Internal' || state.discountImpPromotion) &&
      state.discount_list[discountCode] > 0
   )
      return (
         <div className='row' style={{ order: order }}>
            <div className='col-bhr1'>
               <DiscountDescriptionBox
                  discountDescription={
                     state.discount_list[discountCode]['DiscountDescription']
                  }
                  discountName={'Monthly Promotion'}
                  hoverTitle={getString(
                     'product.ImpPromotionDiscountRow.DiscountDescriptionBox.HoverText',
                  )}
               />
            </div>
            <div className='col'>
               <input
                  className='input-field'
                  type='checkbox'
                  checked={state.discountImpPromotion}
                  disabled={shouldDisableDiscount(state, discountCode)}
                  onChange={() =>
                     state.setDiscountImpPromotion((prev) => !prev)
                  }
               />
            </div>
            <div className='col'>
               {formatFloatAsCurrencySymbol(
                  state.discount_list[discountCode]['DiscountAmount'],
                  state.currencyObject,
               )}
            </div>
         </div>
      )
}
